"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _dompurify = _interopRequireDefault(require("dompurify"));
var _common = require("../../config/common");
var _theme = require("../../config/theme");
var _client = _interopRequireDefault(require("react-dom/client"));
var _string = require("../../utils/type-checks/string");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class AlertFragment extends HTMLElement {
  allowClose;
  componentClass;
  containerClass;
  content;
  contextId;
  defaultIsOpen;
  fragmentId;
  imageAltText;
  imageUrl;
  messageId;
  type;
  initialTheme;
  mountPoint;
  root;
  static get observedAttributes() {
    return ["class", "data-alert-type", "data-allow-close", "data-container-class", "data-context-id", "data-default-is-open", "data-fragment-id", "data-image-alt-text", "data-image-url", "data-message-id", "data-testing-id"];
  }
  attributeChangedCallback(name, oldValue, newValue) {
    let resultTrigger = false;
    if ((0, _string.isStringOfLength)(name) && (0, _string.isStringOfLength)(newValue) && this.root && this.root.render) {
      // eslint-disable-next-line default-case
      switch (name) {
        case "class":
          this.componentClass = newValue;
          this.clearClasses();
          resultTrigger = true;
          break;
        case "data-alert-type":
          this.componentClass = newValue;
          resultTrigger = true;
          break;
        case "data-allow-close":
          this.allowClose = newValue.toLowerCase() === "false" ? false : true;
          resultTrigger = true;
          break;
        case "data-container-class":
          this.containerClass = newValue;
          resultTrigger = true;
          break;
        case "data-context-id":
          this.contextId = newValue;
          resultTrigger = true;
          break;
        case "data-default-is-open":
          this.defaultIsOpen = newValue.toLowerCase() === "true";
          resultTrigger = true;
          break;
        case "data-fragment-id":
          this.fragmentId = newValue;
          resultTrigger = true;
          break;
        case "data-image-alt-text":
          this.imageAltText = newValue;
          resultTrigger = true;
          break;
        case "data-image-url":
          this.imageUrl = newValue;
          resultTrigger = true;
          break;
        case "data-message-id":
          this.messageId = newValue;
          resultTrigger = true;
          break;
        case "data-testing-id":
          this.testId = newValue;
          resultTrigger = true;
          break;
      }
    }
    if (resultTrigger) {
      this.root.render(this.createAlert(this.packageProps()));
    }
  }
  clearClasses() {
    const classList = [...this.classList];
    classList.forEach(value => this.classList.remove(value));
  }
  connectedCallback() {
    this.allowClose = (0, _string.isStringOfLength)(this.getAttribute("data-allow-close")) && this.getAttribute("data-allow-close").toLowerCase() === "false" ? false : true;
    this.componentClass = (0, _string.isStringOfLength)(this.getAttribute("class")) ? this.getAttribute("class") : undefined;
    this.containerClass = (0, _string.isStringOfLength)(this.getAttribute("data-container-class")) ? this.getAttribute("data-container-class") : undefined;
    this.contextId = (0, _string.isStringOfLength)(this.getAttribute("data-context-id")) ? this.getAttribute("data-context-id") : undefined;
    this.content = (0, _string.isStringOfLength)(this.innerHTML) ? this.innerHTML : undefined;
    this.defaultIsOpen = (0, _string.isStringOfLength)(this.getAttribute("data-default-is-open")) ? this.getAttribute("data-default-is-open").toLowerCase() === "true" : !(0, _string.isStringOfLength)(this.contextId) ? true : undefined;
    this.fragmentId = (0, _string.isStringOfLength)(this.getAttribute("data-fragment-id")) ? this.getAttribute("data-fragment-id") : undefined;
    this.imageAltText = (0, _string.isStringOfLength)(this.getAttribute("data-image-alt-text")) ? this.getAttribute("data-image-alt-text") : undefined;
    this.imageUrl = (0, _string.isStringOfLength)(this.getAttribute("data-image-url")) ? this.getAttribute("data-image-url") : undefined;
    this.messageId = (0, _string.isStringOfLength)(this.getAttribute("data-message-id")) ? this.getAttribute("data-message-id") : undefined;
    this.testId = (0, _string.isStringOfLength)(this.getAttribute("data-testing-id")) ? this.getAttribute("data-testing-id") : undefined;
    this.type = (0, _string.isStringOfLength)(this.getAttribute("data-alert-type")) ? this.getAttribute("data-alert-type") : undefined;
    if (this.messageId && (this.fragmentId || this.content)) {
      this.innerHTML = "";
      this.clearClasses();
      this.initialTheme = (0, _theme.GetTheme)();
      this.mountPoint = document.createElement("div");
      this.mountPoint.classList.add("pheaa-custom-element", "pheaa-custom-element__alert");
      this.appendChild(this.mountPoint);
      this.root = _client.default.createRoot(this.mountPoint);
      this.root.render(this.createAlert(this.packageProps()));
    }
  }
  ContentComponent(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: "pheaa-custom-element__alert--isInnerHTML",
      dangerouslySetInnerHTML: {
        __html: _dompurify.default.sanitize(props.content, _common.DOM_PURIFY_OPTIONS)
      }
    });
  }
  createAlert() {
    return /*#__PURE__*/React.createElement(this.component, this.packageProps());
  }
  IconComponent(props) {
    return /*#__PURE__*/React.createElement(_material.Box, {
      alt: props.imageAltText,
      component: "img",
      src: props.imageUrl,
      sx: {
        height: "3.5rem",
        width: "auto"
      }
    });
  }
  packageProps() {
    return {
      allowClose: this.allowClose,
      children: (0, _string.isStringOfLength)(this.content) ? /*#__PURE__*/React.createElement(this.ContentComponent, {
        content: this.content
      }) : undefined,
      className: this.componentClass,
      containerClassName: this.containerClass,
      containerTestId: this.testId,
      contextId: this.contextId,
      customIcon: (0, _string.isStringOfLength)(this.imageUrl) && (0, _string.isStringOfLength)(this.imageAltText) ? /*#__PURE__*/React.createElement(this.IconComponent, {
        imageAltText: this.imageAltText,
        imageUrl: this.imageUrl
      }) : undefined,
      defaultIsOpen: this.defaultIsOpen,
      fragmentId: this.fragmentId,
      id: this.messageId,
      initialTheme: this.initialTheme,
      type: this.type
    };
  }
}
exports.default = AlertFragment;